import React, { useState } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import Loader from "../../../../components/Loader/Loader";

const CustomerIntakeForm = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  const [formValues, setFormValues] = useState({
    CompanyName: "",
    Title: "",
    FirstName: "",
    LastName: "",
    EMail: "",
    PhoneNumber: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    OpeningBalance: "",
  });

  const [loading, setLoading] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState(null);

  const validationSchema = Yup.object().shape({
    CompanyName: Yup.string().required("Comapany Name is required"),
    FirstName: Yup.string().required("First Name is required"),
    LastName: Yup.string().required("Last Name is required"),
    EMail: Yup.string().email().required("E-Mail is required"),
    PhoneNumber: Yup.string()
      .max(10, "Phone number must be at most 10 digits")
      .matches(/^\d+$/, "Phone number must only contain digits")
      .required("Phone number is required"),
    Address1: Yup.string().required("Address 1 is required"),
    Address2: Yup.string().required("Address 2 is required"),
    City: Yup.string().required("City is required"),
    StateProvince: Yup.string().required("State/Province is required"),
    Zip: Yup.string()
      .required("Zip is required")
      .max(6, "Zip Code must be at most 6 digits"),
    Country: Yup.string().required("Country is required"),
    OpeningBalance: Yup.string().required("Opening Balance is Required")
  });

  const title = [
    { label: "Mr.", value: "Mr." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Dr.", value: "Dr." },
    { label: "Hon.", value: "Hon." },
    { label: "Prof.", value: "Prof." },
    { label: "Rev.", value: "Rev." },
    { label: "Rt. Hon.", value: "Rt. Hon." },
    { label: "Sr.", value: "Sr." },
    { label: "Jr.", value: "Jr." },
    { label: "St.", value: "St." },
  ];

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
    }), // dropdown menu css
  };

  const handleSubmit = (values) => {
    setLoading(true);
    axios
      .post(
        `${config.customersBaseUrl}/customers/intakeformupsert`,
        {
          id: paramObject.id || 0,
          companyname: values.CompanyName,
          firstname:
            selectedTitle === null
              ? values.FirstName
              : selectedTitle.value + " " + values.FirstName,
          lastname: values.LastName,
          email: values.EMail,
          phonenumber: values.PhoneNumber,
          address1: values.Address1,
          address2: values.Address2,
          city: values.City,
          state: values.StateProvince,
          zip: values.Zip,
          country: values.Country,
          loginuserid: Id,
          OpeningBalance: values.OpeningBalance
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/customers");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("E-mail" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header"
            style={
              {
                position: "fixed",
                top: "2px",
                zIndex: "999"
              }
            }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Customer</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/customers">Customers List</Link>
                </li>
                <li className="breadcrumb-item active">Customer Intake Form</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Customer Intake Form</h5>
            </div>
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Company Name<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.CompanyName ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="CompanyName"
                              name="CompanyName"
                            />
                            <div className="invalid-feedback">
                              {touched.CompanyName && errors.CompanyName
                                ? errors.CompanyName
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-lg-2 form-label">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-lg-10">
                            <div className="row">
                              <div className="col-lg-3 pe-0">
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={setSelectedTitle}
                                  options={title}
                                  placeholder=""
                                  styles={selectStyles}
                                  value={selectedTitle}
                                  id="Title"
                                  name="Title"
                                  className="custom-search-select"
                                />
                              </div>
                              <div className="col-lg-9 ps-0">
                                <Field
                                  type="text"
                                  className={`form-control form-control-sm ${errors.FirstName ? "is-invalid" : ""
                                    }`}
                                  onChange={handleChange}
                                  id="FirstName"
                                  name="FirstName"
                                />
                                <div className="invalid-feedback">
                                  {touched.FirstName && errors.FirstName
                                    ? errors.FirstName
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.LastName ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="LastName"
                              name="LastName"
                            />
                            <div className="invalid-feedback">
                              {touched.LastName && errors.LastName
                                ? errors.LastName
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            E-Mail <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.EMail ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="EMail"
                              name="EMail"
                            />
                            <div className="invalid-feedback">
                              {touched.EMail && errors.EMail
                                ? errors.EMail
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Phone Number <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="number"
                              className={`form-control form-control-sm custom-invalid-border ${errors.PhoneNumber ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="PhoneNumber"
                              name="PhoneNumber"
                            // maxLength="10"
                            />
                            <div className="invalid-feedback">
                              {touched.PhoneNumber && errors.PhoneNumber
                                ? errors.PhoneNumber
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            City <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.City ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="City"
                              name="City"
                            />
                            <div className="invalid-feedback">
                              {touched.City && errors.City ? errors.City : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-2">
                          <label className="col-form-label col-md-2 form-label">
                            Address 1 <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              as="textarea"
                              className={`form-control form-control-sm ${errors.Address1 ? "is-invalid custom-invalid-border" : ""
                                }`}
                              onChange={handleChange}
                              id="Address1"
                              name="Address1"
                            />
                            <div className="invalid-feedback">
                              {touched.Address1 && errors.Address1
                                ? errors.Address1
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="row mb-2">
                          <label className="col-form-label col-md-2 form-label">
                            Address 2{" "} <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              as="textarea"
                              className={`form-control form-control-sm ${errors.Address2 ? "is-invalid custom-invalid-border" : ""
                                }`}
                              onChange={handleChange}
                              id="Address2"
                              name="Address2"
                            />
                            <div className="invalid-feedback">
                              {touched.Address2 && errors.Address2
                                ? errors.Address2
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            State/Province{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.StateProvince ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="StateProvince"
                              name="StateProvince"
                            />
                            <div className="invalid-feedback">
                              {touched.StateProvince && errors.StateProvince
                                ? errors.StateProvince
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Zip <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.Zip ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Zip"
                              name="Zip"
                              maxLength="6"
                            />
                            <div className="invalid-feedback">
                              {touched.Zip && errors.Zip ? errors.Zip : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Country <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.Country ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="Country"
                              name="Country"
                            />
                            <div className="invalid-feedback">
                              {touched.Country && errors.Country
                                ? errors.Country
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Opening Balance <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.OpeningBalance ? "is-invalid" : ""
                                }`}
                              onChange={handleChange}
                              id="OpeningBalance"
                              name="OpeningBalance"
                            />
                            <div className="invalid-feedback">
                              {touched.OpeningBalance && errors.OpeningBalance
                                ? errors.OpeningBalance
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="pull-right">
                        <Link
                          to="/customers"
                          className="btn btn-sm btn-secondary mb-3 "
                        >
                          Cancel
                        </Link>

                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-3 ms-3"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerIntakeForm;
